import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface ChatBreadcrumbsProps {
  currentLabel: string;
  onOverview: () => void;
}

const ChatBreadcrumbs = ({ currentLabel, onOverview }: ChatBreadcrumbsProps) => (
  <nav className="chat-breadcrumbs" aria-label="Breadcrumb">
    <button type="button" className="chat-breadcrumb-link" onClick={onOverview}>
      Overview
    </button>
    <ChevronRightIcon className="chat-breadcrumb-separator" fontSize="small" />
    <span className="chat-breadcrumb-current">{currentLabel}</span>
  </nav>
);

export default ChatBreadcrumbs;
